// store name shown in redux store
export const STORE_NAME = 'audioPlayerStore'
